import { createCardAward } from '@lc/interface/card/award/factory';

export const AwardMeta = [
	createCardAward(
		100,
		`HAVE THE BIGGEST R AND EVEN BIGGER D`,
		`HAVE THE MOST EQUIPMENT CARDS IN PLAY`,
		`PUT TWO (2) ENERGY INTO YOUR CUP FOR EACH EQUIPMENT CARD YOU OWN`
	),
	createCardAward(
		101,
		`DAS EXHAUSTING`,
		`HAVE THE LOWEST CARBON FOOTPRINT`,
		`TAKE THE DIFFERENCE BETWEEN THE HIGHEST CARBON FOOTPRINT AND YOUR CARBON FOOTPRINT AND PLACE THAT AMOUNT OF ENERGY IN YOUR CUP`
	),
	createCardAward(
		102,
		`ENDORSED BY COSMETICS COMPANY`,
		`HAVE THE MOST PR`,
		`TAKE THE DIFFERENCE BETWEEN YOUR PR AND THE LOWEST PR AND PLACE THAT AMOUNT OF ENERGY IN YOUR CUP`
	),
	createCardAward(
		103,
		`FOAM FINGER TROPHY`,
		`HAVE THE GREATEST HAND SIZE`,
		`TAKE THE DIFFERENCE BETWEEN YOUR HAND SIZE AND THE LOWEST HAND SIZE AND PLACE THAT AMOUNT IN YOUR CUP`
	),
	createCardAward(
		104,
		`INDUSTRIALIST AWARD`,
		`HAVE THE MOST FACTORIES`,
		`PUT ONE (1) ENERGY INTO YOUR CUP FOR EACH FACTORY YOU HAVE`
	),
	createCardAward(
		105,
		`GOVERNMENT EMPLOYEE OF THE MONTH`,
		`HAVE THE MOST CONTRACTS IN COMPLETED PILE`,
		`PUT ONE (1) ENERGY IN YOUR CUP PER CONTRACT YOUR NEIGHBORS HAVE FAILED`
	),
	createCardAward(
		106,
		`GOVERNMENT EMPLOYEE OF THE MONTH`,
		`HAVE THE MOST CONTRACTS IN FAILED PILE`,
		`PUT ONE (1) ENERGY IN YOUR CUP PER CONTRACT YOUR NEIGHBORS HAVE FAILED`
	),
	createCardAward(
		107,
		`POWER E-CIGS WORLDWIDE`,
		`HAVE THE MOST PR`,
		`PUT ONE (1) ENERGY INTO YOUR CUP FOR EACH BATTERY YOU OWN`
	),
	createCardAward(
		108,
		`NO ENERGY LEFT BEHIND`,
		`PLAYERS COMPETE TO HAVE THE SAME PR`,
		`IF ANY PARTICIPANTS HAVE THE SAME PR, THEY PUT ENERGY INTO THEIR CUP EQUAL TO THEIR CURRENT PR AMOUNT *IN THE EVENT OF A TIE, AT LEAST TWO PEOPLE WIN*`
	),
	createCardAward(
		109,
		`MOST AESTHETIC ELECTRIC FENCE`,
		`HAVE THE MOST CHARGED BATTERIES AT NEXT SUMMIT`,
		`WINNER PUTS ENERGY INTO THEIR CUP EQUAL TO THE NUMBER OF CHARGED BATTERIES THEY OWN`
	),
	createCardAward(
		110, // TODO
		`FERVENT FILIBUSTER`,
		`CONTRIBUTE THE LEAST THIS SUMMIT`,
		`DISTRIBUTE UP TO FIVE (5) CARBON FROM YOUR CARBON FOOTPRINT AMONGST NEIGHBORS AS YOU SEE FIT`
	),
	createCardAward(
		111,
		`KEEPING CURRENT`,
		`HAVE THE MOST BATTERIES`,
		`PUT ONE (1) ENERGY INTO YOUR CUP FOR EACH BATTERY YOU HAVE`
	),
	createCardAward(
		112,
		`BEST LOOKING UPPER MANAGEMENT`,
		`HAVE THE MOST PR`,
		`PUT ONE (1) ENERGY INTO YOUR CUP FOR EACH BATTERY YOU HAVE`
	),
	createCardAward(
		113,
		`NEPOTISM`,
		`HAVE THE FEWEST FACTORIES`,
		`PUT ONE (1) ENERGY INTO YOUR CUP FOR EACH FACTORY A NEIGHBOR OF YOUR CHOICE HAS` // HIGHEST # OF FACTORIES
	),
	createCardAward(
		114,
		`BLACK FRIDAY LINE LEADER`,
		`HAVE THE FEWEST BATTERIES`,
		`PUT ONE (1) ENERGY INTO YOUR CUP FOR EACH BATTERY A NEIGHBOR OF YOUR CHOICE HAS` // HIGHEST # OF BATTERIES
	),
	createCardAward(
		115, // TODO
		`MAKIN’ IT (ACID) RAIN`,
		`HAVE THE LARGEST CARBON FOOTPRINT`,
		`PLACE UP TO FIVE (5) CARBON FROM YOUR FOOTPRINT INTO THE FOOTPRINT OF A NEIGHBOR OF YOUR CHOICE`,
		true
	),
	createCardAward(
		116, // TODO
		`INDEPENDENT NOMINEE`,
		`HAVE THE LOWEST PR`,
		`STEAL AN UNPLAYED SUMMIT CARD FROM A NEIGHBOR (*WITHOUT LOOKING*)`,
		true
	),
];
